var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#262551"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_667_11078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.484 24.6807C20.2599 24.6807 24.5142 18.2369 24.5142 12.6506C24.5142 12.4695 24.5101 12.2843 24.5021 12.1031C25.3297 11.5046 26.0439 10.7633 26.6111 9.914C25.8404 10.2569 25.022 10.4809 24.1841 10.5782C25.0664 10.0494 25.727 9.21853 26.0435 8.23975C25.2135 8.73166 24.3057 9.07866 23.3592 9.26588C22.7215 8.58825 21.8783 8.13957 20.96 7.98923C20.0416 7.83888 19.0994 7.99524 18.2788 8.43413C17.4583 8.87301 16.8052 9.56998 16.4205 10.4173C16.0358 11.2646 15.9409 12.215 16.1506 13.1216C14.4699 13.0373 12.8257 12.6007 11.3245 11.8401C9.82338 11.0796 8.49883 10.012 7.43674 8.70672C6.89693 9.63742 6.73174 10.7387 6.97476 11.7869C7.21778 12.835 7.85076 13.7512 8.74506 14.3494C8.07367 14.3281 7.41699 14.1473 6.82928 13.8221V13.8744C6.82867 14.8511 7.16633 15.7979 7.78484 16.5538C8.40336 17.3097 9.26456 17.828 10.2221 18.0208C9.60012 18.1909 8.94737 18.2157 8.31432 18.0932C8.58451 18.9332 9.11019 19.6679 9.81801 20.1947C10.5258 20.7215 11.3805 21.0142 12.2626 21.0319C10.765 22.2084 8.9149 22.8465 7.01043 22.8435C6.67268 22.8429 6.33527 22.8222 6 22.7815C7.93474 24.0227 10.1854 24.6819 12.484 24.6807Z",
    fill: "#8E97CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_667_11078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6111,
    height: 20.6111,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsTwitter);
export default __webpack_public_path__ + "static/media/newsTwitter.13d14f58f8006bd7ab289da81d4a88fa.svg";
export { ForwardRef as ReactComponent };